import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import useGenerateOptions from "../../../components/input/hook/useGenerateOptions2";
import { useDownloadBlobAsFile } from "../../../hooks/useDownloadBlobAsFile";
import { ENV_LISTS } from "../../../core/EnvTranspiler";
import { useGetBrands } from "../../produk/api/product/brand/resolver";
import { useGetCategory } from "../../produk/api/product/category/resolver";

interface ExportReportForm {
  start_date: string;
  end_date: string;
  product_brand_id: string;
  product_category_id: string;
}

interface ExportReportDialogProps {
  defaultStartDate?: string;
  defaultEndDate?: string;
}

export default function ExportReportDialog({
  defaultStartDate,
  defaultEndDate,
}: ExportReportDialogProps) {
  const [keywordBrand, setKeywordBrand] = useState("");
  const [keywordKategori, setKeywordKategori] = useState("");
  const { download, isLoading: isLoadingDownload } = useDownloadBlobAsFile();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ExportReportForm>({
    defaultValues: {
      start_date: defaultStartDate || "",
      end_date: defaultEndDate || "",
      product_brand_id: "",
      product_category_id: "",
    },
  });

  const { data: dataRawBrands, isLoading: fetchBrands } = useGetBrands({
    keyword: keywordBrand,
    page: 1,
  });
  const dataBrands = dataRawBrands?.data.data.data;
  const { data: dataBrandOptions } = useGenerateOptions({
    dataSource: dataBrands,
    keyForText: "brand_name",
    keyForValue: "id",
  });
  const { data: dataRawCategories, isLoading: fetchCategories } =
    useGetCategory({ page: 1, keyword: keywordKategori });
  const dataCategories = dataRawCategories?.data.data.data;
  const { data: dataCategoriesOptions } = useGenerateOptions({
    dataSource: dataCategories,
    keyForText: "category_name",
    keyForValue: "id",
  });

  const handleDownload = (form: ExportReportForm) => {
    const params = new URLSearchParams();
    Object.entries(form).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      }
    });
    const url = `${ENV_LISTS.API_URL}/invoice/report/export?${params.toString()}`;
    download(url, `Laporan_Invoice_${form.start_date}_${form.end_date}`);
  };

  return (
    <Box width={400} mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Input.Controller
            control={control}
            name="start_date"
            rules={{ required: "Tanggal awal wajib diisi" }}
            render={(field) => (
              <Input.Date
                label="Tanggal Awal"
                value={field.value}
                error={errors.start_date?.message}
                onChange={(e) => field.onChange(e)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Input.Controller
            control={control}
            name="end_date"
            rules={{ required: "Tanggal akhir wajib diisi" }}
            render={(field) => (
              <Input.Date
                label="Tanggal Akhir"
                value={field.value}
                error={errors.end_date?.message}
                onChange={(e) => field.onChange(e)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Input.Controller
            control={control}
            name="product_brand_id"
            render={(field) => (
              <Input.Autocomplete
                isFetching={fetchBrands}
                options={dataBrandOptions || []}
                label="Brand Produk"
                value={field.value}
                onChange={(e) => setKeywordBrand(e)}
                onClick={(e) => field.onChange(e.value)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Input.Controller
            control={control}
            name="product_category_id"
            render={(field) => (
              <Input.Autocomplete
                isFetching={fetchCategories}
                options={dataCategoriesOptions || []}
                label="Kategori Produk"
                value={field.value}
                onChange={(e) => setKeywordKategori(e)}
                onClick={(e) => field.onChange(e.value)}
              />
            )}
          />
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <LoadingButton
          text="Download"
          isLoading={isLoadingDownload}
          onClick={handleSubmit(handleDownload)}
        />
      </Box>
    </Box>
  );
}
